// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
// 引入element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import global_ from '../src/views/Global.vue' // 这个路径是相对于main.js的相对路径

Vue.prototype.GLOBAL = global_
import App from './App';
// 引入路由
import router from './router';
// 引入状态管理
import store from './vuex/store';
// 引入icon
import './assets/icon/iconfont.css'
//

// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import  VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)



import VueVideoPlayer from 'vue-video-player'

// 引入样式
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'

// 使用组件
Vue.use(VueVideoPlayer)


// import axios from 'axios';
// Vue.prototype.$axios = axios;
Vue.config.productionTip = false;
Vue.component('ExTable',ExTable)
Vue.component('ExTableColumn',ExTableColumn)
Vue.component('ExSelect',ExSelect)

// 使用element UI
Vue.use(ElementUI);
// 过滤器
import * as custom from './utils/util'
import ExSelect from "./components/ExSelect/index.vue";
import ExTableColumn from "./components/ExTable/ex-table-column.vue";
import ExTable from "./components/ExTable/ex-table.vue";
Object.keys(custom).forEach(key => {
    Vue.filter(key, custom[key])
})
new Vue({
    el: '#app',
    router,
    store, //使用store vuex状态管理
    components: { App },
    template: '<App/>',
    data: {
        // 空的实例放到根组件下，所有的子组件都能调用
        Bus: new Vue()
    }

})



// WEBPACK FOOTER //
// ./src/main.js